import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useHasPermission } from '@/hooks/usePermission';

interface Props {
  name: string;
  children: ReactNode;
}

/**
 * Route guard: renders children when the current user has the named permission,
 * otherwise redirects to /forbidden. Backend authorization is still the source
 * of truth for data access; this is for UI deep-link safety.
 */
export function RequirePermission({ name, children }: Props) {
  const allowed = useHasPermission(name);
  if (!allowed) return <Navigate to="/forbidden" replace state={{ requiredPermission: name }} />;
  return <>{children}</>;
}
